import { useCallback, useEffect, useRef } from 'react';
import { useSettingValueByCode } from '../contexts/SettingsContext';
import { getActivityLogDetails } from '../services/api-service';
import { getUserId } from '../services/auth-service';
import { getAgentAlertMessages } from '../utils/agentAlertsUtil';

const useAgentAlertsPolling = () => {
	const activityLoadingRef = useRef(false);
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
	let refreshInterval = useSettingValueByCode("ACTV_ALT_INTERVAL") || 0;

	const fetchAgentAlerts = useCallback(async () => {
		if (activityLoadingRef.current) {
			return;
		}
		activityLoadingRef.current = true;
		try {
			const userId = getUserId();
			if (!userId || typeof Notification === 'undefined') {
				return;
			}

			if (Notification.permission === 'default') {
				const permission = await Notification.requestPermission();
				if (permission !== 'granted') {
					return;
				}
			} else if (Notification.permission !== 'granted') {
				return;
			}

			const agentData = await getActivityLogDetails();
			getAgentAlertMessages(agentData);
		} catch (error) {
			console.error('Error fetching agent alerts:', error);
		} finally {
			activityLoadingRef.current = false;
		}
	}, []);

	useEffect(() => {
		let interval: number = Number(refreshInterval);
		interval = isNaN(interval) ? 0 : interval * 1000;
		if (interval < 1) {
			return;
		}
		if (interval < 5000) {
			interval = 5000
		}
		fetchAgentAlerts();
		intervalRef.current = setInterval(fetchAgentAlerts, interval);

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, [fetchAgentAlerts, refreshInterval]);
};

export default useAgentAlertsPolling;
